import { useState } from "react";
import { Copy } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { WEEKDAY_LABELS } from "@/utils/weekdays";

type CopyDayPopoverProps = {
  sourceWeekday: number;
  onCopy: (targets: number[]) => void;
};

const WORKDAYS = [1, 2, 3, 4, 5];

export const CopyDayPopover = ({ sourceWeekday, onCopy }: CopyDayPopoverProps) => {
  const [open, setOpen] = useState(false);
  const [targets, setTargets] = useState<number[]>([]);

  const others = WEEKDAY_LABELS.map((_, weekday) => weekday).filter(
    (weekday) => weekday !== sourceWeekday
  );

  const toggle = (weekday: number) =>
    setTargets((prev) =>
      prev.includes(weekday) ? prev.filter((value) => value !== weekday) : [...prev, weekday]
    );

  const apply = () => {
    onCopy(targets);
    setTargets([]);
    setOpen(false);
  };

  return (
    <Popover
      open={open}
      onOpenChange={(value) => {
        setOpen(value);
        if (!value) setTargets([]);
      }}
    >
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" size="sm" className="flex gap-1 w-fit">
          <Copy className="size-4" />
          Copiar para outros dias
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-64 flex flex-col gap-3">
        <div className="flex gap-2">
          <Button
            type="button"
            variant="outline"
            size="sm"
            onClick={() => setTargets(WORKDAYS.filter((weekday) => weekday !== sourceWeekday))}
          >
            Seg a Sex
          </Button>
          <Button type="button" variant="outline" size="sm" onClick={() => setTargets(others)}>
            Todos
          </Button>
        </div>
        <div className="flex flex-col gap-2">
          {others.map((weekday) => (
            <label key={weekday} className="flex items-center gap-2 text-sm cursor-pointer">
              <Checkbox
                checked={targets.includes(weekday)}
                onCheckedChange={() => toggle(weekday)}
              />
              {WEEKDAY_LABELS[weekday]}
            </label>
          ))}
        </div>
        <Button type="button" size="sm" disabled={targets.length < 1} onClick={apply}>
          Copiar
        </Button>
      </PopoverContent>
    </Popover>
  );
};
